var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationNodataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M32,50a3.006,3.006,0,0,0,2.829-2H29.171A3.006,3.006,0,0,0,32,50Z",
    fill: "#ef6f6f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(36 14)",
    fill: "#ef6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M49,4H15A11.013,11.013,0,0,0,4,15V49A11.013,11.013,0,0,0,15,60H49A11.013,11.013,0,0,0,60,49V15A11.013,11.013,0,0,0,49,4Zm1,40.936A3.036,3.036,0,0,1,47,48H36.9a5,5,0,0,1-9.8,0H17a3.036,3.036,0,0,1-3-3.064V43.9a3.036,3.036,0,0,1,3-3.064,1.036,1.036,0,0,0,1-1.065V28.419a14.667,14.667,0,0,1,4.5-10.588,13.693,13.693,0,0,1,10.18-3.814,13.083,13.083,0,0,1,2.117.3,4.991,4.991,0,1,1,8.306,5.53A15.34,15.34,0,0,1,46,28.8V39.774a1.035,1.035,0,0,0,1,1.065A3.036,3.036,0,0,1,50,43.9Z",
    fill: "#ef6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M47,42.839a3.037,3.037,0,0,1-3-3.065V28.8a13.34,13.34,0,0,0-2.364-7.569A4.945,4.945,0,0,1,34.08,16.2a10.757,10.757,0,0,0-1.5-.19,11.655,11.655,0,0,0-8.7,3.264A12.66,12.66,0,0,0,20,28.419V39.774a3.037,3.037,0,0,1-3,3.065A1.035,1.035,0,0,0,16,43.9v1.033A1.035,1.035,0,0,0,17,46H47a1.035,1.035,0,0,0,1-1.064V43.9A1.034,1.034,0,0,0,47,42.839Z",
    fill: "#ef6f6f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNodataIcon);
export default __webpack_public_path__ + "static/media/notification_nodata_icon.ca0947578b6f14e1dfc19836963f5721.svg";
export { ForwardRef as ReactComponent };